// @ts-nocheck
import React from 'react';
import { Modal, Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import CancelScheduleSendIcon from '@mui/icons-material/CancelScheduleSend';

const Root = styled('div')(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    boxShadow: 24,
    padding: '25px',
    width: 420,
    [theme.breakpoints.down('sm')]: {
        width: '85%',
    },
}));

export default function CancelarProgramacionModal({ open, onClose, handleDelete }) {
    const handleConfirm = () => {
        onClose();
        handleDelete();
    };

    return (
        <Modal open={open} onClose={onClose}>
                <Root>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <CancelScheduleSendIcon color="primary" />
                            <Typography variant="h6">Cancelar Programación</Typography>
                        </Box>

                        <Typography variant="body1" color="text.secondary">
                            La programación del envío será <strong>cancelada</strong>. Esta acción no puede deshacerse.
                        </Typography>

                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                            <Button sx={{ textTransform: 'none' }} variant="outlined" onClick={onClose}>
                                Volver
                            </Button>
                            <Button sx={{ textTransform: 'none' }} variant="contained" color="primary" onClick={handleConfirm}>
                                Confirmar
                            </Button>
                        </Box>
                    </Box>
                </Root>
            </Modal>
    );
}
